<template>
    <div class="user-info" ref="box">
        <a-dropdown
            :trigger="['hover']"
            placement="bottomCenter"
            :getPopupContainer="getPopupContainerHandle"
            @visibleChange="visibleChange"
            @click="e => e.preventDefault()"
        >
            <div class="user">
                <img src="./img/h2.svg" alt />
                <div>
                    <span>{{ userName }}</span>
                    <img src="./img/h3.svg" alt :class="[visible && 'active']" />
                </div>
            </div>
            <template #overlay>
                <div class="dropdown-box">
                    <div class="triangle">
                        <div></div>
                    </div>
                    <div
                        v-for="(v, k) in userList"
                        :key="k"
                        :class="[k !== userList.length - 1 && 'has-border']"
                        @click="clickHandel(v)"
                        v-show="!v.hidden"
                    >
                        <img :src="v.icon" alt v-if="v.icon" />
                        <span>{{ v.text }}</span>
                    </div>
                </div>
            </template>
        </a-dropdown>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    props: ['userName'],

    data() {
        return {
            visible: false
        };
    },

    computed: {
        userList() {
            return [
                {
                    text: '个人中心 ',
                    name: 'personalCenter',
                    hidden: this.$route.name === 'personalCenter'
                },
                {
                    text: '注销'
                }
            ];
        }
    },

    methods: {
        ...mapActions(['signOut']),

        clickHandel(val) {
            this.visible = false;
            if (val.name) {
                this.$router.push({
                    name: val.name
                });
            } else {
                this.$confirm('', '确定注销系统').then(async () => {
                    await this.signOut(() => {
                        setTimeout(() => {
                            this.$router.push({ name: 'home' });
                        }, 1 * 1000);
                    });
                });
            }
        },

        getPopupContainerHandle() {
            return this.$refs.box;
        },

        visibleChange(visible) {
            this.visible = visible;
        }
    }
};
</script>

<style lang="scss" scoped>
.user-info {
    .user {
        margin-left: 24px;
        display: flex;
        align-items: center;
        cursor: pointer;

        > img {
            width: 24px;
            height: 24px;
        }

        > div {
            display: flex;
            align-items: center;
            margin-left: 8px;

            > span {
                font-size: 16px;
                color: #333333;
                letter-spacing: 0;
                text-align: center;
                font-weight: 600;
                margin-right: 2px;
            }

            > img {
                transition-duration: 0.2s;
            }

            > .active {
                transform: rotate(-180deg);
            }
        }
    }
}

.dropdown-box {
    padding: 8px 0;
    background: #ffffff;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.06);
    position: relative;

    > div:not(.triangle) {
        height: 40px;
        display: flex;
        align-items: center;
        padding: 0 16px;
        font-size: 14px;
        color: #333333;
        letter-spacing: 0;
        font-weight: 400;

        > img {
            margin-right: 4px;
        }
    }

    > div:not(.triangle):hover {
        background: #cee7ff;
        cursor: pointer;
    }

    > .has-border {
        border-bottom: 1px solid #d9d9d9;
    }
}
</style>
